/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlListRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlListRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlListRequest>): ComplianceAssessmentControlListRequest {
        let obj = Object.assign(new ComplianceAssessmentControlListRequest(), model);
        ComplianceAssessmentControlListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlListRequest>): ComplianceAssessmentControlListRequest {
        if (!model) return null;
        return ComplianceAssessmentControlListRequest.newInstance(<ComplianceAssessmentControlListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlListRequest) {
        if (!obj) return;

        models.ComplianceAssessmentControlListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlListRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ComplianceAssessmentControlDetailFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ComplianceAssessmentControlSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ComplianceAssessmentControlSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ComplianceAssessmentControlDetailFilter;

}
